import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Swal from 'sweetalert2';
import { login } from '../api/data';

const Auth = ({ close }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async () => {
    const response = await login({ username, password });

    if (response.status === 'success') {
      // Store user data in sessionStorage
      localStorage.setItem('user', JSON.stringify(response.user));

      Swal.fire({
        icon: 'success',
        title: 'Login Successful',
        text: response.message,
        timer: 2000,
        showConfirmButton: false,
      });
      close();
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Login Failed',
        text: response.message,
      });
    }
  };

  return (
    <div className="popup-overlay">
      <motion.div
        className="popup-layer"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.9 }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
      >
        <div className="title">
          Sign in
          <button onClick={close}>Close</button>
        </div>
        <div className="form-grid">
          <label htmlFor="username">
            <span>Username</span><br />
            <input
              type="text"
              id="username"
              name="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </label>
          <label htmlFor="password">
            <span>Password</span><br />
            <input
              type="password"
              id="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
        </div>

        <div className="form-submission">
          <button onClick={handleLogin}>Login</button>
        </div>
      </motion.div>
    </div>
  );
};

export default Auth;